import React from "react";
import LazyLoadSection from "../Components/LazyLoadSection";

export default function FAQ() {
  return (
    <>
      <LazyLoadSection className="section-container">
        <h2>What should I wear or bring?</h2>
        <p>
          <strong>Clothing:</strong> Warm, flexible layers, long socks, and
          gloves or mittens. Depending on the type of lesson and your
          experience, make sure you can remove layers if needed!
        </p>
        <p>
          <strong>Gear:</strong> Rental skates are fine for beginners and can be
          found at the ice arena. Some people feel more comfortable with pads on
          for their first time!
        </p>
      </LazyLoadSection>

      <LazyLoadSection className="section-container">
        <h2>I've never been on the ice before, I have no prior experience</h2>
        <p>
          No prior experience is necessary - you've come to the right place!
        </p>
      </LazyLoadSection>

      <LazyLoadSection className="section-container">
        <h2>When is a good time to get an ice coach and lessons?</h2>
        <p>
          Everyone is different. I coach all ages, from young children who have
          an interest in ice skating and may well go on to be performers or
          coaches themselves, people who have just started and want to learn
          things the right way from the get-go, and seasoned skaters looking to
          learn new skills or dust off some rust for an upcoming event.
        </p>
        <p>There is no wrong time to start lessons.</p>
      </LazyLoadSection>

      <LazyLoadSection className="section-container">
        <h2>What sort of structure is there for lessons?</h2>
        <p>
          We can tailor the lessons to your needs, just let me know your goals.
        </p>
      </LazyLoadSection>

      <LazyLoadSection className="section-container">
        <h2>Pricing and costs</h2>
        <p>
          Coaching prices can be found on the bookings page. There are further
          discounts available for pre-paid repeat bookings, which we can discuss
          if you're interested in booking a few months in advance, such as a
          weekly lesson.
        </p>
        <p>
          Additional costs include ice time - this is through the ice arena and
          I've no control over it - and skate hire, if you need them.
        </p>
      </LazyLoadSection>

      <LazyLoadSection className="section-container">
        <h2>Do you accommodate group bookings?</h2>
        <p>Please give me a call for your needs.</p>
      </LazyLoadSection>
    </>
  );
}
